import React from 'react';
import { connect } from 'react-redux';
import Text from '../../Common/Form/Text';
import Continue from '../../Common/Continue';
import { OptionGroup, OptionItem } from '../../ui';
import seriousDiseasesImage from '../../../assets/health/icon-serious-diseases.png';
import oncologicalImage from '../../../assets/health/icon-oncological.png';
import { setHealthValue } from '../../../actions';
import { useContinue } from './useContinue';

const SaludForm2 = ({ disease, onValueChange }) => {
  const isValidForm = useContinue(disease !== null);

  return (
    <div>
      <Text className="Text-question" style={{ marginBottom: 40 }}>
        ¿Frente a cuál de estos inconvenientes de Salud quieres estar protegido?
      </Text>

      <OptionGroup>
        <OptionItem
          active={disease === 0}
          onClick={() => onValueChange('disease', 0)}
        >
          <img src={seriousDiseasesImage} alt="" />
          Enfermedades graves
        </OptionItem>

        <OptionItem
          active={disease === 1}
          onClick={() => onValueChange('disease', 1)}
        >
          <img src={oncologicalImage} alt="" />
          Oncológico
        </OptionItem>
      </OptionGroup>

      <Continue state={isValidForm} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    disease: state.health.disease
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onValueChange: (type, value) => {
      dispatch(setHealthValue(type, value));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaludForm2);
